import { type ReactNode } from 'react'

interface ArkCommandShellProps {
  children: ReactNode
}

export function ArkCommandShell({ children }: ArkCommandShellProps) {
  return (
    <div className="h-screen w-screen bg-ark-void flex flex-col overflow-hidden text-ark-text font-sans antialiased">
      {children}
    </div>
  )
}
